import React, { createContext, useContext, useMemo } from 'react'
import { useExperienceApi } from './api'
import formatExperience, { Experience } from './formatExperience'

export type ExperienceContextValue = Experience & {
  isReady: boolean
  isError: boolean
}

export const ExperienceContext = createContext<ExperienceContextValue>({
  isReady: false,
  isError: false,
  ...formatExperience(),
})

export const useExperience = () => useContext(ExperienceContext)

export const ExperienceProvider = ({
  children,
}: {
  children?: React.ReactNode
}) => {
  const { data, isError, isReady } = useExperienceApi()

  const contextValue = useMemo(
    () => ({
      isReady,
      isError,
      ...formatExperience(data),
    }),
    [data, isReady, isError],
  )

  return (
    <ExperienceContext.Provider value={contextValue}>
      {children}
    </ExperienceContext.Provider>
  )
}
